import { connect } from 'react-redux';
import Details from './details';

export default connect()(Details);
